var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacktoTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "72px",
    viewBox: "0 0 71 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "66DFA60D-7909-44DB-9F5E-D9EC9F7B98D8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.43652778 8.45387941 0 28.8244824 8.10138889 49.5645961 28.4604167 58 48.5661111 48.9417065 57 28.5790216 48.9909722 8.43540387 28.6240278 0"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.2%",
    y: "-16.4%",
    width: "140.4%",
    height: "139.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet-and-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet---Giving-History---Recurring-Gifts",
    transform: "translate(-679.000000, -2284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top-copy",
    transform: "translate(686.000000, 2289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back-to-top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.8,
    fill: "#8BB8E8",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.8195612,27.8949815 L37.8523417,27.9019704 L23.8001009,27.9019704 L28.2176121,23.5870325 C28.4339291,23.3763691 28.5525876,23.0909918 28.5525876,22.7914705 C28.5525876,22.4919491 28.4339291,22.2085687 28.2176121,21.9974061 L27.5302464,21.3271439 C27.3141001,21.1164805 27.0260758,21 26.7189295,21 C26.4116125,21 26.1234174,21.1156485 25.9072711,21.3263119 L18.3348094,28.7060188 C18.1178094,28.9175142 17.9991509,29.1992306 18.0000046,29.4989184 C17.9991509,29.8002702 18.1178094,30.082153 18.3348094,30.2933156 L25.9072711,37.6736881 C26.1234174,37.8841851 26.4114418,38 26.7189295,38 C27.0260758,38 27.3141001,37.8840187 27.5302464,37.6736881 L28.2176121,37.0034259 C28.4339291,36.7930953 28.5525876,36.5122109 28.5525876,36.2126895 C28.5525876,35.9133346 28.4339291,35.6472598 28.2176121,35.4367628 L23.7502472,31.0976968 L37.8352685,31.0976968 C38.4681708,31.0976968 39,30.5660464 39,29.9495316 L39,29.0015465 C39,28.3850318 38.4524635,27.8949815 37.8195612,27.8949815 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(28.500000, 29.500000) scale(1, -1) rotate(-90.000000) translate(-28.500000, -29.500000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktoTop);
export default __webpack_public_path__ + "static/media/BacktoTop.228aa9fe71f06d5dce3157554a02a993.svg";
export { ForwardRef as ReactComponent };